import Vue from 'vue'
import VueRouter from 'vue-router'

import auth from './middleware/auth'
import guest from './middleware/guest'

import People from '../pages/people/Page.vue'
import PeopleTable from '../pages/people/Table.vue'
import Report from '../pages/reports/Page.vue'

import LoginPage from '../pages/login/Page.vue'
import Login from '../pages/login/Login.vue'
import LoginJWT from '../pages/login/LoginJWT.vue'
import ChangePass from '../pages/login/ChangePass.vue'
import RecoveryPass from '../pages/login/RecoveryPass.vue'
import Page404 from '../pages/404.vue'

Vue.use(VueRouter)


const routes = [
  { path: '', redirect: '/peoples' },
  {
    path: '/login',
    component: LoginPage,
    children: [
      {
        path: '',
        name: 'login',
        component: Login,
        meta: {
          middleware: guest
        },
      },
      {
        path: 'jwt/:token',
        name: 'loginJWT',
        component: LoginJWT,
      },
      {
        path: 'recovery-pass',
        name: 'recovery-pass',
        component: RecoveryPass,
      },
      {
        path: 'change-pass',
        name: 'change-pass',
        component: ChangePass,
      },
    ]
  },
  {
    path: '/peoples/:id?',
    component: People,
    children: [
      {
        path: '',
        name: 'people',
        component: PeopleTable,
        meta: {
          middleware: auth
        },
      },
    ],
  },
  {
    path: '/reports/',
    component: Report,
    name: 'reports',
    meta: {
      middleware: auth
    },
  },
  {
    path: '*',
    name: '404',
    component: Page404
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
  }
  return middleware(context)
})

export default router